import { Paginated, Run } from "@/types";
import { get } from "./client";

export interface ListFlowRunsParams {
  stepId?: string | null;
  status?: "success" | "failure" | "unknown" | "all";
  includeDeletedSteps?: boolean;
  limit?: number;
  offset?: number;
}

export async function listFlowRuns(
  flowId: string,
  params: ListFlowRunsParams = {},
): Promise<Paginated<Run>> {
  const query = new URLSearchParams();
  if (params.stepId) query.set("step_id", params.stepId);
  if (params.status && params.status !== "all") {
    query.set("status", params.status);
  }
  if (params.includeDeletedSteps) {
    query.set("include_deleted_steps", "true");
  }
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  const qs = query.toString();
  return get<Paginated<Run>>(`/runs/flow/${flowId}${qs ? `?${qs}` : ""}`);
}

export interface ListStepRunsParams {
  limit?: number;
  offset?: number;
}

export async function listStepRuns(
  stepId: string,
  params: ListStepRunsParams = {},
): Promise<Paginated<Run>> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  const qs = query.toString();
  return get<Paginated<Run>>(`/runs/step/${stepId}${qs ? `?${qs}` : ""}`);
}
